//Access User Name by ID or Email and so on

export type UserType = {
  id: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
  organization_id__name: string;
  email: string;
};

export const createUserLookupMaps = (users: UserType[]) => {
  const byId = new Map<string, UserType>();
  const byEmail = new Map<string, UserType>();

  users.forEach((user) => {
    byId.set(String(user.id), user); // convert to string as we get id as a string from API
    byEmail.set(user.email, user);
  });

  return {
    byId,
    byEmail,
    getFullNameById: (id: string) => {
      const user = byId.get(id);
      return user ? `${user.first_name} ${user.last_name}` : null;
    },
    getFullNameByEmail: (email: string) => {
      const user = byEmail.get(email);
      return user ? `${user.first_name} ${user.last_name}` : null;
    },
    getUserBy: (field: keyof UserType, value: any) =>
      users.find((user) => user[field] === value) ?? null,
  };
};
